mutation RegenerateBackupCodes {
  regenerateBackupCodes(input: {}) {
    backupCodes
    errors
  }
}
